import { useContext } from 'react';
import { AuthContext } from '../contexts/Auth/AuthContext';
export var useAuth = function () {
    var context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return {
        userInfo: context.userInfo,
        login: context.login,
        loginWithToken: context.loginWithToken,
        logout: context.logout,
        hasPermission: context.hasPermission,
        initialized: context.initialized,
        authenticated: context.isAuthenticated,
    };
};
